import { render, staticRenderFns } from "./FactorInvoiceDetail.vue?vue&type=template&id=d6888b18&scoped=true"
import script from "./FactorInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./FactorInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./FactorInvoiceDetail.vue?vue&type=style&index=0&id=d6888b18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6888b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6888b18')) {
      api.createRecord('d6888b18', component.options)
    } else {
      api.reload('d6888b18', component.options)
    }
    module.hot.accept("./FactorInvoiceDetail.vue?vue&type=template&id=d6888b18&scoped=true", function () {
      api.rerender('d6888b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/factorinvoice/FactorInvoiceDetail.vue"
export default component.exports